// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"057f80d4","239":"4cd860a8","447":"d9434766","488":"5dc00adb","732":"3fba199a","967":"17ba87a1"}[chunkId] + ".chunk.js";
};